// Cache-key conventions and invalidation helpers for TanStack Query.

export const invalidatePaymentRequests = (queryClient) =>
  queryClient.invalidateQueries({ queryKey: ["paymentRequests"] });

// Call when the merchant's people change — a user added, edited or removed, whether that
// happened in this tab or arrived as a realtime hint. Names shown around the app are resolved
// from this list client-side, so it going stale is what users would notice.
export const invalidateUsers = (queryClient) =>
  queryClient.invalidateQueries({ queryKey: ["users"] });

// Prefix-invalidates both the notification feed and unread-count queries — call after a mark-read
// action or a realtime "new notification" hint.
export const invalidateNotifications = (queryClient) =>
  queryClient.invalidateQueries({ queryKey: ["notifications"] });
